import React from 'react'

const TextInputPhoneNumber = ({ value, onChange }) => {
  return (
    <div>
      <label className="block text-gray-700 mb-2" htmlFor="phone">
        Nomor Telepon
      </label>
      <input
        type="tel"
        id="phone"
        name="phone"
        value={value}
        onChange={onChange}
        placeholder="Masukkan nomor telepon Anda"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
        required
      />
    </div>
  )
}

export default TextInputPhoneNumber